// MEGMA deploy refresh 2026-08-02 23:20 HKT
(() => {
  'use strict';

  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const pushEvent = (eventName) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName });
  };

  ready(() => {
    const style = document.createElement('style');
    style.id = 'megma-optimization-styles';
    style.textContent = `
      .announcement-flashing-wrapper { background-color: #8a4632 !important; }
      .announcement__text { animation: none !important; opacity: 1 !important; }
      .section__title-desc,
      .section__title-desc a,
      .product-card__vendor,
      .quantity-selector,
      .product-form__stock-note { color: #4a4a4a !important; opacity: 1 !important; }
      .megma-whatsapp-launcher {
        position: fixed; right: 18px; bottom: 18px; z-index: 40;
        display: inline-flex; min-width: 54px; min-height: 54px;
        align-items: center; justify-content: center; gap: 8px;
        padding: 12px 16px; border: 0; border-radius: 999px;
        background: #0d743d; color: #fff; font: inherit; font-weight: 700;
        box-shadow: 0 8px 26px rgba(0,0,0,.24); cursor: pointer; text-decoration: none;
      }
      .megma-whatsapp-launcher:hover { background: #095a30; }
      .megma-whatsapp-launcher:focus-visible {
        outline: 3px solid #111; outline-offset: 3px;
      }
      .megma-whatsapp__button { background: #0d743d !important; }
      .megma-whatsapp__button:hover { background: #095a30 !important; }
      .megma-whatsapp-menu-link {
        display: inline-flex !important; align-items: center; justify-content: center;
        gap: 7px; margin: 0 6px; padding: 10px 16px !important;
        border-radius: 999px; background: #0d743d !important; color: #fff !important;
        font-weight: 700; line-height: 1.2; text-decoration: none;
      }
      .megma-whatsapp-menu-link:hover { background: #095a30 !important; color: #fff !important; }
      .megma-whatsapp-menu-link:focus-visible {
        outline: 3px solid #111; outline-offset: 3px;
      }
      .secondary-nav__item.megma-whatsapp-menu-item {
        margin-left: 12px;
      }
      .secondary-nav__item .megma-whatsapp-menu-link {
        min-width: 44px; min-height: 44px;
        margin: 0; padding: 9px 12px !important;
        white-space: nowrap; letter-spacing: normal;
      }
      .mobile-nav__item--megma-whatsapp { padding: 12px 20px; }
      .mobile-nav__item--megma-whatsapp .megma-whatsapp-menu-link {
        display: flex !important; min-height: 48px; margin: 0; padding: 12px 18px !important;
      }
      .megma-deferred-video[data-loaded="true"] .megma-deferred-video__player {
        position: absolute; inset: 0; z-index: 1;
        width: 100%; height: 100%; object-fit: cover;
        opacity: 1 !important; visibility: visible !important;
      }
      .megma-whatsapp-launcher:focus-visible {
        outline: 3px solid #111; outline-offset: 3px;
      }
      .megma-product-trust {
        margin-top: 16px; padding: 14px 16px; border: 1px solid #d6d8d4;
        border-radius: 10px; background: #f7f8f6; color: #27312c;
        font-size: 14px; line-height: 1.55;
      }
      .megma-product-trust p { margin: 0; }
      .megma-product-trust p + p { margin-top: 5px; }
      .megma-product-trust a { color: #27312c; text-decoration: underline; }
      @media (max-width: 480px) {
        .megma-whatsapp-launcher { right: 14px; bottom: 14px; padding: 12px; }
        .megma-whatsapp-launcher__label { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); }
      }
      @media (prefers-reduced-motion: reduce) {
        *, *::before, *::after {
          scroll-behavior: auto !important;
          animation-duration: .01ms !important;
          animation-iteration-count: 1 !important;
          transition-duration: .01ms !important;
        }
      }
    `;
    document.head.appendChild(style);

    document.querySelector('.main#main')?.setAttribute('role', 'main');

    document.addEventListener('click', (event) => {
      const playButton = event.target.closest('.js-megma-video-play');
      if (!playButton) return;

      const container = playButton.closest('[data-megma-deferred-video]');
      if (!container || container.dataset.loaded === 'true') return;

      const videoSource = playButton.dataset.videoSrc;
      const youtubeId = playButton.dataset.youtubeId;
      const posterSource = container.querySelector('img')?.currentSrc
        || container.querySelector('img')?.src;
      let player;

      if (videoSource) {
        player = document.createElement('video');
        player.className = 'megma-deferred-video__player';
        player.controls = true;
        player.playsInline = true;
        player.preload = 'metadata';
        player.setAttribute('aria-label', playButton.getAttribute('aria-label') || '影片');
        if (posterSource) player.poster = posterSource;
        player.src = videoSource;
      } else if (youtubeId) {
        player = document.createElement('iframe');
        player.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(youtubeId)}?autoplay=1&rel=0&playsinline=1`;
        player.title = playButton.getAttribute('aria-label') || '影片';
        player.allow = 'autoplay; encrypted-media; picture-in-picture';
        player.allowFullscreen = true;
      } else {
        return;
      }

      container.dataset.loaded = 'true';
      container.replaceChildren(player);
      if (player instanceof HTMLVideoElement) {
        player.play().catch(() => {});
      }
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches && window.jQuery) {
      window.jQuery('.js-home-carousel').on('init', function (event, slider) {
        slider.slickPause();
      });
      document.querySelectorAll('.js-home-carousel').forEach((carousel) => {
        if (carousel.slick) carousel.slick.slickPause();
      });
    }

    document.querySelectorAll('a.home-image-grid__link').forEach((link) => {
      const hasName = link.getAttribute('aria-label')
        || link.textContent.trim()
        || link.querySelector('img[alt]:not([alt=""])');
      if (hasName) return;

      const slug = (link.getAttribute('href') || '')
        .split('?')[0]
        .split('/')
        .filter(Boolean)
        .pop()
        ?.replace(/[-_]+/g, ' ');
      link.setAttribute('aria-label', slug ? `查看 ${slug}` : '查看產品');
    });

    const isChinese = document.documentElement.lang.toLowerCase().startsWith('zh');
    const whatsAppCopy = isChinese
      ? {
          menuLabel: 'WhatsApp 聯絡我們',
          menuAria: '透過 WhatsApp 聯絡我們',
          launcherAria: '透過 WhatsApp 聯絡我們',
          message: '你好，我想查詢 MEGMA INNOVATION 的產品。'
        }
      : {
          menuLabel: 'Contact us on WhatsApp',
          menuAria: 'Contact us on WhatsApp',
          launcherAria: 'Contact us on WhatsApp',
          message: 'Hello, I would like to ask about a MEGMA INNOVATION product.'
        };
    const whatsAppMenuUrl = `https://wa.me/85251076037?text=${encodeURIComponent(whatsAppCopy.message)}`;
    const addWhatsAppMenuItem = (menu, mobile = false) => {
      if (!menu || menu.querySelector('[data-megma-whatsapp-menu]')) return;

      const item = document.createElement('li');
      item.className = mobile
        ? 'mobile-nav__item mobile-nav__item--megma-whatsapp'
        : 'secondary-nav__item megma-whatsapp-menu-item';

      const link = document.createElement('a');
      link.href = whatsAppMenuUrl;
      link.className = mobile
        ? 'mobile-nav__link megma-whatsapp-menu-link'
        : 'secondary-nav__link megma-whatsapp-menu-link';
      link.target = '_blank';
      link.rel = 'noopener';
      link.dataset.megmaWhatsappMenu = '';
      link.setAttribute('aria-label', whatsAppCopy.menuAria);
      const visibleLabel = mobile ? whatsAppCopy.menuLabel : 'WhatsApp';
      link.innerHTML = `<span aria-hidden="true">☎</span><span>${visibleLabel}</span>`;
      link.addEventListener('click', () => pushEvent('whatsapp_menu_click'));

      item.appendChild(link);
      menu.appendChild(item);
    };

    addWhatsAppMenuItem(document.querySelector('.secondary-nav__items'));
    addWhatsAppMenuItem(document.querySelector('.mobile-nav__items'), true);

    if (isChinese) {
      if (window.theme?.t) {
        window.theme.t.add_to_cart = '加入購物車';
        window.theme.t.sold_out = '售罄';
        window.theme.t.unavailable = '暫不可選';
      }

      const exactReplacements = new Map([
        ['Collection list', '選購類別'],
        ['View all', '查看全部'],
        ['Learn more', '了解更多'],
        ['Subscribe', '訂閱'],
        ['Language', '語言'],
        ['You may also like', '你可能也喜歡'],
        ['Regular price', '一般價格'],
        ['Add to cart', '加入購物車'],
        ['Sold Out', '售罄']
      ]);

      const fallbackReplacements = new Map([
        ['Menu', '選單'],
        ['Search', '搜尋'],
        ['Cart', '購物車']
      ]);

      const textNodeReplacements = new Map([
        ['Skip to content', '前往主要內容'],
        ['Regular price', '一般價格'],
        ['You may also like', '你可能也喜歡'],
        ['Reduce item quantity by one', '減少一件'],
        ['Increase item quantity by one', '增加一件'],
        ['Shopping Cart', '購物車'],
        ['Shipping & taxes calculated at checkout', '運費及稅項於結帳時計算'],
        ['Check Out', '結帳'],
        ['Continue shopping', '繼續購物'],
        ['Subtotal', '小計'],
        ['Your cart is currently empty.', '購物車目前是空的。'],
        ['Shop now', '立即選購'],
        ['Email', '電郵']
      ]);

      const translateTextNode = (node) => {
        const original = node.nodeValue.trim();
        if (textNodeReplacements.has(original)) {
          node.nodeValue = node.nodeValue.replace(original, textNodeReplacements.get(original));
        } else if (original.startsWith('Subtotal ')) {
          node.nodeValue = node.nodeValue.replace('Subtotal ', '小計 ');
        }
      };

      const translateTextNodes = (root) => {
        if (!(root instanceof Node)) return;
        if (root.nodeType === Node.TEXT_NODE) {
          translateTextNode(root);
          return;
        }
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        const textNodes = [];
        while (walker.nextNode()) textNodes.push(walker.currentNode);

        textNodes.forEach((node) => {
          translateTextNode(node);
        });
      };

      document.querySelectorAll('.icon-fallback__text').forEach((element) => {
        const original = element.textContent.trim();
        if (fallbackReplacements.has(original)) {
          element.textContent = fallbackReplacements.get(original);
        }
      });

      translateTextNodes(document.body);

      const translateAccessibleLabels = (root = document) => {
        if (!(root instanceof Element || root instanceof Document)) return;
        const elements = root instanceof Element && root.matches('[aria-label]')
          ? [root, ...root.querySelectorAll('[aria-label]')]
          : root.querySelectorAll('[aria-label]');

        elements.forEach((element) => {
          const label = element.getAttribute('aria-label');
          if (label === 'quantity') element.setAttribute('aria-label', '數量');
          if (label === 'Reduce item quantity by one') element.setAttribute('aria-label', '減少一件');
          if (label === 'Increase item quantity by one') element.setAttribute('aria-label', '增加一件');
          if (label === 'close') element.setAttribute('aria-label', '關閉');
          if (label === 'Email') element.setAttribute('aria-label', '電郵');
          if (label?.startsWith('Load image into Gallery viewer, ')) {
            element.setAttribute('aria-label', label.replace('Load image into Gallery viewer, ', '載入圖片至圖庫：'));
          }
        });
      };

      translateAccessibleLabels();

      const translationObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            translateTextNodes(node);
            if (node instanceof Element) translateAccessibleLabels(node);
          });
        });
      });
      translationObserver.observe(document.body, { childList: true, subtree: true });

      document.querySelectorAll('h2, h3, button, a, .js-product-add-text').forEach((element) => {
        const original = element.textContent.trim();
        if (exactReplacements.has(original)) {
          element.textContent = exactReplacements.get(original);
        }
      });

      document.querySelectorAll('label.quantity-selector').forEach((label) => {
        label.textContent = '數量：';
      });

      document.querySelectorAll('.js-price-stock-note').forEach((note) => {
        const quantity = note.querySelector('span')?.textContent.trim();
        if (quantity) note.innerHTML = `僅餘 <span>${quantity}</span> 件`;
      });

      document.querySelectorAll('.js-qty__adjust--minus .u-hidden-visually').forEach((element) => {
        element.textContent = '減少一件';
      });
      document.querySelectorAll('.js-qty__adjust--plus .u-hidden-visually').forEach((element) => {
        element.textContent = '增加一件';
      });
    }

    const buyButtons = document.querySelector('.product-single__box__block--buy_buttons');
    if (buyButtons && !document.querySelector('.megma-product-trust')) {
      const trust = document.createElement('aside');
      trust.className = 'megma-product-trust';
      trust.setAttribute('aria-label', '購買保障');
      trust.innerHTML = `
        <p><strong>Polaroid 香港官方代理</strong></p>
        <p><a href="/policies/refund-policy">收貨後 14 日內可申請退貨</a>（須符合退款政策條件）</p>
        <p>送貨時間及費用以結帳頁顯示為準。</p>
      `;
      buyButtons.insertAdjacentElement('afterend', trust);
    }

    const whatsAppDialog = document.getElementById('MegmaWhatsAppDialog');
    if (whatsAppDialog) {
      if (whatsAppDialog.open) whatsAppDialog.close();
      whatsAppDialog.show = () => {};
      whatsAppDialog.showModal = () => {};
      whatsAppDialog.hidden = true;
      whatsAppDialog.setAttribute('aria-hidden', 'true');
    }

    if (!document.querySelector('.megma-whatsapp-launcher')) {
      const launcher = document.createElement('a');
      launcher.href = whatsAppMenuUrl;
      launcher.target = '_blank';
      launcher.rel = 'noopener';
      launcher.className = 'megma-whatsapp-launcher';
      launcher.setAttribute('aria-label', whatsAppCopy.launcherAria);
      launcher.innerHTML = '<span aria-hidden="true">☎</span><span class="megma-whatsapp-launcher__label">WhatsApp</span>';
      launcher.addEventListener('click', () => pushEvent('whatsapp_click'));
      document.body.appendChild(launcher);
    }
  });
})();
